import {Alert} from "@mui/material";
import useAuth from "src/hooks/useAuth";
import useLocales from "src/hooks/useLocales";
import fetchUser from "src/utils/fetchUser";
import {setSession} from "src/utils/jwt";

const ImpersonationBanner = () => {
    const {translate} = useLocales();
    const {user} = useAuth();
    const isImpersonate = localStorage.getItem("isImpersonate");

    // If user is the main admin (user_id = 1 or username 'summusadmin'), clear impersonation flag
    if (isImpersonate && (user?.id === 1 || user?.username === 'summusadmin')) {
        localStorage.removeItem("isImpersonate");
        return null;
    }

    const goBackToAdmin = async () => {
        try {
            const {
                status,
                data: {access_token},
            } = await fetchUser.get("back-to-admin");
            if (status === 200) {
                localStorage.setItem("isAdmin", true);
                localStorage.removeItem("isSubAdmin");
                localStorage.removeItem("isImpersonate");
                setSession(access_token);
                window.location = `${window.origin}${sessionStorage.getItem(
                    "impersonationSource"
                )}`;
            }
        } catch (err) {
            console.error(err);
        }
    };

    // Impersonating: mostro solo il banner di impersonation per tornare admin.
    // Il banner "training" e' stato rimosso (sara' sostituito da una CTA piu'
    // integrata nel dashboard).
    if (isImpersonate) {
        return (
            <Alert severity="info">
                {translate("impersonation.heads")} {user.username}.{" "}
                <strong
                    onClick={goBackToAdmin}
                    style={{
                        textDecoration: "none",
                        cursor: "pointer",
                    }}
                >
                    {translate("impersonation.click")}
                </strong>{" "}
                {translate("impersonation.toGo")}
            </Alert>
        );
    }

    return null;
};

export default ImpersonationBanner;
